/**
 * "How did you hear about us?" attribution options for event
 * registration. Shared so the web dropdown, the backend validation,
 * and the admin display all agree on the same values + labels.
 */
export const HEARD_ABOUT_US_OPTIONS = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "friend", label: "A friend" },
  { value: "family", label: "Family" },
  { value: "member", label: "I'm already a member of Vihangam Yog" },
  { value: "past_event", label: "A past Vihangam Yog event" },
  { value: "other", label: "Other / prefer not to say" },
] as const;

export type HeardAboutUs = (typeof HEARD_ABOUT_US_OPTIONS)[number]["value"];

/** Non-empty tuple form for `z.enum(...)`; the head is the first option, so the tuple is never empty. */
const [firstHeardAboutUs, ...otherHeardAboutUs] = HEARD_ABOUT_US_OPTIONS.map(
  (o) => o.value,
);
export const HEARD_ABOUT_US_VALUES: [HeardAboutUs, ...HeardAboutUs[]] = [
  firstHeardAboutUs,
  ...otherHeardAboutUs,
];

/** Human label for a stored value; "—" when unset. */
export function heardAboutUsLabel(value: string | null | undefined): string {
  if (!value) {
    return "—";
  }
  return HEARD_ABOUT_US_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
